import PublicPotreeViewer from '../viewer/PublicPotreeViewer';

function PublicViewerWrapper() {

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        width: "100%",
        height: "100%",
        overflow: "hidden",
      }}
    >
        <PublicPotreeViewer />
      </div>

  );
}

export default PublicViewerWrapper;
